import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Switch,
  Button,
  Divider,
  IconButton,
  Paper,
  Stack,
  InputBase
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Popover, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import adCenterApi from '../adCenterApi';

import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { DateRange } from 'react-date-range';
import { enUS } from 'date-fns/locale'; // ✅ locale required

import 'react-date-range/dist/styles.css'; // ✅ main style
import 'react-date-range/dist/theme/default.css'; // ✅ theme style
import { useNavigate } from 'react-router-dom';



const CampaignDashboard = () => {
      const navigate = useNavigate();
  
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [campaignStatusFilter, setCampaignStatusFilter] = useState('INACTIVE');
  const [timePeriod, setTimePeriod] = useState('28D');

  const handleCalendarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCalendarClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  useEffect(() => {
    console.log('range.startDate', range.startDate);

    
    fetchCampaignInsights();
  }, [campaignStatusFilter, timePeriod, range[0].startDate, range[0].endDate]);

  const fetchCampaignInsights = async () => {
      setLoading(true);
      try {
        const response = await adCenterApi.post('/getCampaignInsightDetails', {
          adminUser: localStorage.getItem('uuid'),
          brokerId: localStorage.getItem('brokerId'),
          campaignStatus: campaignStatusFilter,
          timePeriod: timePeriod,
          startDate: dayjs(range[0].startDate).format('YYYY-MM-DD'),
          endDate: dayjs(range[0].endDate).format('YYYY-MM-DD'),
        });
        setCampaigns(response.data?.campaignInsightDetails || []);
        setSelectedCampaign((response.data?.campaignInsightDetails || [])[0] || null);
      } catch (err) {
        setCampaigns([]);
        setSelectedCampaign(null);
      } finally {
        setLoading(false);
      }
    };

  const filteredCampaigns = campaigns.filter(c => c.campaignName?.toLowerCase().includes(search.toLowerCase()));

  return (
    <Box sx={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh', p: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          width: '100%',
        }}
      >
        {/* Sidebar */}
        <Box sx={{ width: { xs: '100%', md: '260px', lg: '300px' }, flexShrink: 0, mb: { xs: 2, md: 0 } }}>
          <Card sx={{ backgroundColor: '#1a1a1a', p: { xs: 1.5, md: 2 }, minWidth: 0 }}>
            <Box display="flex" alignItems="center" mb={2}>
              <SearchIcon fontSize="small" sx={{ mr: 1 }} />
              <InputBase
                placeholder="Search campaigns"
                value={search}
                onChange={e => setSearch(e.target.value)}
                sx={{ color: '#fff', width: '100%' }}
              />
            </Box>
            <Divider sx={{ borderColor: '#333', mb: 2 }} />
            <Box>
              {loading ? (
                <Stack spacing={2}>
                  {[...Array(2)].map((_, i) => (
                    <Card key={i} sx={{ backgroundColor: '#222', mb: 2, p: 1, minHeight: 60 }} />
                  ))}
                </Stack>
              ) : (
                filteredCampaigns.map((campaign, index) => (
                  <Card
                    key={campaign.campaignId || index}
                    sx={{ backgroundColor: selectedCampaign?.campaignId === campaign.campaignId ? '#222b36' : '#222', mb: 2, p: 1, border: selectedCampaign?.campaignId === campaign.campaignId ? '2px solid #1976d2' : 'none', cursor: 'pointer' }}
                    onClick={() => setSelectedCampaign(campaign)}
                  >
                    <Typography variant="body2" gutterBottom noWrap>{campaign.campaignName}</Typography>
                    <Typography variant="caption" display="block" gutterBottom>
                      ID: {campaign.campaignId}
                    </Typography>
                    {/* <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="caption">{campaign.campaignStatus || 'PAUSED'}</Typography>
                      <Switch size="small" defaultChecked={campaign.campaignStatus === 'ACTIVE'} color="warning" />
                    </Box> */}
                  </Card>
                ))
              )}
            </Box>
          </Card>
        </Box>

        {/* Main Content */}
        <Box sx={{ flex: 1, width: '100%' }}>
          
          
          {/* Filter/Toolbar Card */}
<Card sx={{ backgroundColor: '#1a1a1a', mb: 2, p: { xs: 1.5, md: 2 }, borderRadius: 3, boxShadow: '0 1px 6px 0 rgba(0,0,0,0.12)' }}>
  <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} gap={2}>
    {/* Dropdown for Active/Inactive Campaigns */}
    <Box sx={{ minWidth: 180 }}>
      <TextField
        select
        label="Campaign Status"
        value={campaignStatusFilter}
        onChange={e => setCampaignStatusFilter(e.target.value)}
        SelectProps={{ native: true }}
        size="small"
        sx={{ backgroundColor: '#222', borderRadius: 1, color: '#fff', minWidth: 180 }}
        InputLabelProps={{ style: { color: '#b0b8c1' } }}
      >
        <option value="ACTIVE">Active Campaigns</option>
        <option value="INACTIVE">Inactive Campaigns</option>
      </TextField>
    </Box>
    
    {/* Calendar Button */}
    <Box display="flex" gap={1} alignItems="center" mb={{ xs: 1, sm: 0 }}>
      <IconButton color="primary" onClick={handleCalendarClick} size="large">
        <CalendarTodayIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleCalendarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box className="dark-date-range-wrapper" sx={{ p: 2, display: 'flex', gap: 2 }}>
            <DateRange
              editableDateInputs={true}
              onChange={item => setRange([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={range}
              locale={enUS}
            />
          </Box>
        </LocalizationProvider>
      </Popover>
    </Box>
    
    {/* Time Period Buttons */}
    <Box display="flex" gap={1} width={{ xs: '100%', sm: 'auto' }}>
      {['7D', '28D', '3M', '1Y'].map(label => (
        <Button
          key={label}
          variant={label === timePeriod ? 'contained' : 'outlined'}
          sx={{ textTransform: 'none', flex: 1 }}
          onClick={() => setTimePeriod(label)}
        >
          {label}
        </Button>
      ))}
    </Box>
    
    {/* Spacer to push buttons to the right */}
    <Box sx={{ flexGrow: 1 }} />
    
    {/* New Create Campaign Button */}
    <Button
      variant="contained"
      color="primary"
      sx={{ 
        textTransform: 'none',
        minWidth: 160,
        backgroundColor: '#1976d2',
        '&:hover': { backgroundColor: '#1565c0' }
      }}
      onClick={() => navigate('/create-campaign')}

    >
      Create Campaign
    </Button>
    
    {/* New Create Audience Button */}
    <Button
      variant="outlined"
      color="primary"
      sx={{ 
        textTransform: 'none',
        minWidth: 160,
        borderColor: '#1976d2',
        color: '#1976d2',
        '&:hover': { 
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          borderColor: '#1565c0',
          color: '#1565c0'
        }
      }}
      onClick={() => navigate('/create-audience')}
      
    >
      Create Audience
    </Button>
  </Box>
</Card>

          {/* Stats Card with Header */}
          <Card sx={{ backgroundColor: '#181c24', mb: 3, p: { xs: 1.5, md: 3 }, borderRadius: 3, boxShadow: '0 2px 16px 0 rgba(0,0,0,0.18)' }}>
            {/* <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} mb={2}>
              <Typography variant="h6" sx={{ mb: { xs: 1, sm: 0 } }}>{selectedCampaign?.campaignName || 'Select a Campaign'}</Typography>
              <Button variant="outlined" sx={{ textTransform: 'none', width: { xs: '100%', sm: 'auto' }, mt: { xs: 1, sm: 0 } }}>
                Analyze Campaign with Grok
              </Button>
            </Box> */}
            <Box display="flex" flexWrap="wrap" gap={2} justifyContent="space-between">
              {selectedCampaign ? [
                { label: 'Impressions', value: selectedCampaign.impressions ?? '—' },
                { label: 'Spend Caps Amount', value: selectedCampaign.spendCapsAmount != null ? `$${selectedCampaign.spendCapsAmount}` : '—' },
                { label: 'Link Clicks', value: selectedCampaign.linkClicked ?? '—' },
                { label: 'Link Click Rate', value: selectedCampaign.linkClickedRate != null ? `${selectedCampaign.linkClickedRate}%` : '—' },
                { label: 'Cost Per Link Click', value: selectedCampaign.costPerLinkClicked != null ? `$${selectedCampaign.costPerLinkClicked}` : '—' },
                { label: 'Daily Budget', value: selectedCampaign.dailyBudget != null ? `$${selectedCampaign.dailyBudget}` : '—' },
              ].map((stat, idx) => (
                <Card key={stat.label} sx={{ backgroundColor: '#232a36', borderRadius: 2, boxShadow: '0 1px 6px 0 rgba(0,0,0,0.12)', p: 2, minWidth: 0, flex: '1 1 220px', maxWidth: '250px', mb: 0 }}>
                  <Typography variant="subtitle2" color="#b0b8c1">{stat.label}</Typography>
                  <Typography variant="h5" fontWeight={600} mt={1}>{stat.value}</Typography>
                </Card>
              )) : null}
            </Box>
          </Card>

          {/* Chart Card with Header */}
          {/* <Card sx={{ backgroundColor: '#181c24', p: { xs: 1.5, md: 3 }, borderRadius: 3, boxShadow: '0 2px 16px 0 rgba(0,0,0,0.18)' }}>
            <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} mb={2}>
              <Typography variant="h6" sx={{ mb: { xs: 1, sm: 0 } }}>Campaign Charts</Typography>
              <Button variant="outlined" sx={{ textTransform: 'none', width: { xs: '100%', sm: 'auto' }, mt: { xs: 1, sm: 0 } }}>
                Analyze Campaign with Grok
              </Button>
            </Box>
            <Box display="flex" flexWrap="wrap" gap={2} justifyContent="space-between">
              {[
                'Impressions',
                'Spend',
                'Link Clicks',
                'Link Click Rate',
                'Cost Per Link Click',
                'Daily Budget',
              ].map((label, idx) => (
                <Card key={label} sx={{ backgroundColor: '#232a36', borderRadius: 2, boxShadow: '0 1px 6px 0 rgba(0,0,0,0.12)', height: 170, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: 2, minWidth: 0, flex: '1 1 220px', maxWidth: '250px', mb: 0 }}>
                  <Typography variant="subtitle2" color="#b0b8c1">{label}</Typography>
                  <Box mt={2} width="100%">
                    <Typography variant="caption" color="gray" align="center">[Chart Placeholder]</Typography>
                  </Box>
                </Card>
              ))}
            </Box>
          </Card> */}
        </Box>
      </Box>
    </Box>
  );
};

export default CampaignDashboard;
